export const ALL_ORGANIZATIONS_ID = 'all';
export const NEW_ID = 'new';
